import React from 'react';
import { Link } from 'react-router-dom';

const PageBanner = ({ title, subtitle, breadcrumbs = [], backgroundImage, fallback, loading = false }) => {
  const src = backgroundImage || fallback;
  return (
    <div className="page-hero">
      {loading ? null : <img src={src} alt={title || 'Banner'} className="page-hero-img" />}
      <div className="page-hero-content">
        <div className="container">
          <div className="page-hero-inner">
            <div className="w-full text-center">
              {title && (
                <h1 className="h-display text-white mb-2">
                  {title}
                </h1>
              )}
              {subtitle && (
                <p className="text-white text-center text-lg md:text-xl font-medium opacity-90 max-w-3xl mx-auto">
                  {subtitle}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageBanner;
